import createAccountForm from './create-account-form'

export { createAccountForm }

export default { createAccountForm }